import React from "react";

export default function TableIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2899_725)">
        <path
          d="M12.6667 0H3.33333C2.4496 0.00105857 1.60237 0.352588 0.97748 0.97748C0.352588 1.60237 0.00105857 2.4496 0 3.33333L0 12.6667C0.00105857 13.5504 0.352588 14.3976 0.97748 15.0225C1.60237 15.6474 2.4496 15.9989 3.33333 16H12.6667C13.5504 15.9989 14.3976 15.6474 15.0225 15.0225C15.6474 14.3976 15.9989 13.5504 16 12.6667V3.33333C15.9989 2.4496 15.6474 1.60237 15.0225 0.97748C14.3976 0.352588 13.5504 0.00105857 12.6667 0ZM1.33333 3.33333C1.33333 2.8029 1.54405 2.29419 1.91912 1.91912C2.29419 1.54405 2.8029 1.33333 3.33333 1.33333H12.6667C13.1971 1.33333 13.7058 1.54405 14.0809 1.91912C14.456 2.29419 14.6667 2.8029 14.6667 3.33333V5.33333H1.33333V3.33333ZM14.6667 12.6667C14.6667 13.1971 14.456 13.7058 14.0809 14.0809C13.7058 14.456 13.1971 14.6667 12.6667 14.6667H3.33333C2.8029 14.6667 2.29419 14.456 1.91912 14.0809C1.54405 13.7058 1.33333 13.1971 1.33333 12.6667V6.66667H14.6667V12.6667Z"
          fill="#36363D"
        />
        <path
          d="M12.6667 3.99996C13.0349 3.99996 13.3333 3.70148 13.3333 3.33329C13.3333 2.9651 13.0349 2.66663 12.6667 2.66663C12.2985 2.66663 12 2.9651 12 3.33329C12 3.70148 12.2985 3.99996 12.6667 3.99996Z"
          fill="#36363D"
        />
        <path
          d="M9.99992 3.99996C10.3681 3.99996 10.6666 3.70148 10.6666 3.33329C10.6666 2.9651 10.3681 2.66663 9.99992 2.66663C9.63173 2.66663 9.33325 2.9651 9.33325 3.33329C9.33325 3.70148 9.63173 3.99996 9.99992 3.99996Z"
          fill="#36363D"
        />
        <path
          d="M7.33341 3.99996C7.7016 3.99996 8.00008 3.70148 8.00008 3.33329C8.00008 2.9651 7.7016 2.66663 7.33341 2.66663C6.96522 2.66663 6.66675 2.9651 6.66675 3.33329C6.66675 3.70148 6.96522 3.99996 7.33341 3.99996Z"
          fill="#36363D"
        />
      </g>
      <defs>
        <clipPath id="clip0_2899_725">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
